<template>
    <div class="my-creations">
        <sidebar class="my-creations__sidebar"></sidebar>
        <sidebar-mobile class="my-creations__sidebar-mobile"></sidebar-mobile>
        <dashboard-creator-name
            class="my-creations__creator-name"
        ></dashboard-creator-name>
        <view-all-my-creations
            :assets="shownAssets"
            :total-assets-count="assets.count"
            :assets-shown="assets.length"
            :pagination="pagination"
            class="my-creations__my-creations"
            @update:loadMore="loadMore"
        ></view-all-my-creations>
    </div>
</template>

<script>
import ViewAllMyCreations from '@/components/my_creations/sections/ViewAllMyCreations';
import Sidebar from '@/components/sidebar/index';
import SidebarMobile from '@/components/sidebar_mobile/index';
import DashboardCreatorName from '@/components/dashboard/sections/DashboardCreatorName';

import AssetsResource from '@/services/assets';
import { addErrorNotification } from '../../lib/notifications';

export default {
    name: 'Index',
    components: {
        ViewAllMyCreations,
        Sidebar,
        SidebarMobile,
        DashboardCreatorName,
    },
    data() {
        return {
            assets: [],
            shownAssets: [],
        };
    },
    computed: {
        pagination() {
            let query = this.$route.query;
            let params = {
                limit: 10,
                offset: 0,
                order_direction: ['desc'],
                order_fields: ['released_at'],
            };

            if (Object.keys(query).length > 0) {
                if (query.limit) {
                    params.limit = parseInt(query.limit);
                }
                if (query.offset) {
                    params.offset = parseInt(query.offset);
                }
            }
            return params;
        },
    },
    watch: {
        pagination() {
            this.getAssets();
        },
    },
    mounted() {
        this.getAssets();
    },
    methods: {
        async getAssets() {
            try {
                let response = await AssetsResource.getAll({
                    params: this.pagination,
                });
                this.assets = response.data;
                this.assets.rows.forEach(element => {
                    this.shownAssets.push(element);
                });
            } catch (error) {
                addErrorNotification('Error fetching assets.');
                return;
            }
        },
        async updateUrl() {
            await this.$router
                .replace({
                    query: this.pagination,
                })
                .catch(() => {});
        },
        loadMore(offset, limit) {
            this.pagination.offset = offset;
            this.pagination.limit = limit;
            this.updateUrl();
        },
    },
};
</script>

<style scoped lang="scss">
.my-creations {
    @include main-grid-container;
    &__sidebar {
        grid-column: col-start / span 3;
        grid-row: auto;
    }
    &__sidebar-mobile {
        grid-column: col-start / span 13;
        grid-row: auto;
    }
    &__creator-name {
        grid-column: col-start 4 / 13;
        grid-row: 1;
        position: relative;
        @media (max-width: $sm-up) {
            .dashboard-container__creator-name {
                display: none;
            }
        }
    }
    &__my-creations {
        margin-top: -800px;
        position: relative;
        grid-column: col-start 4 / 13;
        grid-row: auto;
        background: $white-main;
        height: auto;
        @media (max-width: $lg-up) {
            grid-column: col-start / 13;
            margin-top: 4rem;
        }
    }
    &__load-more {
        position: relative;
        grid-column: col-start 4 / 13;
        grid-row: auto;
        height: auto;
        @media (max-width: $sm-up) {
            grid-column: col-start / 13;
            margin-top: 0;
            margin-bottom: 20%;
        }
    }
}
</style>
